import { ApiRequestError } from '@chipn/api-client';
import { QueryClient } from '@tanstack/react-query';

/** Retry flaky networks with backoff, but never retry client errors (4xx). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => {
        if (err instanceof ApiRequestError && err.status >= 400 && err.status < 500) return false;
        return count < 3;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
    },
    mutations: { retry: false },
  },
});
